<header class="py-5 d-flex align-items-center">
  <div class="container">
    <div class="text-center">
      <img class="img-desk" src="assets/images/A4U_Logo_Thank_You.png" alt="Apply4u" title="Apply4u">
    </div>
    <div class="mt-3">
      <h1 class="text-center h1 text-white">Please Wait...</h1>
    </div>
  </div>
</header>

 